export const PopularTopicsExtraLinks = {
  'Change Information': {
    helpCenter: "see All",
    linkName: "See All",
    title: "title",
    url: "/help/articles?hc=membershipRewards&ctgry=changeMembershipInformation",
    ariaLabel: "See All Change Information",
  },
  'Member Rewards': {
    helpCenter: "see All",
    linkName: "See All",
    title: "Member Rewards",
    url: "/help/articles?hc=membershipRewards&ctgry=memberRewards",
    ariaLabel: "See All Member Rewards",
  },
  'Linking Membership with account': {
    helpCenter: "see All",
    linkName: "See All",
    title: "Member Rewards",
    url: "/help/articles?hc=accountLogin&ctgry=linkingMembershipAndAccount",
    ariaLabel: "See All Linking Membership with account",
  },
  'Delivery Issues': {
    key: "default_section1_card1_SeeAll",
    url: "/help/categories?hc=myOrders",
    urlOrder: 6,
    urlText: "See All",
    ariaLabel: "See All Delivery Issues",
  },
  "Returns": {
    key: "default_section1_card2_SeeAll",
    url: "/help/helpCenters?hc=returnsExchanges",
    urlOrder: 6,
    urlText: "See All",
    ariaLabel: "See All Returns and Exchanges",
  },
};